import { render } from "./AuCheckbox.vue?vue&type=template&id=245d4582&scoped=true"
import script from "./AuCheckbox.vue?vue&type=script&lang=js"
export * from "./AuCheckbox.vue?vue&type=script&lang=js"

import "./AuCheckbox.vue?vue&type=style&index=0&id=245d4582&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245d4582"]])

export default __exports__